module.exports = __webpack_public_path__ + "media/gcc_introductions/anker_link_arrow-98a31316.png";